module.exports = __webpack_public_path__ + "resources/img/img-vormetric-encryption-m-jp.a3657bf5d9c8f8a60beae87d7b4300ba.png";